import React from 'react';
import { about, education, hikingList, myPhotos } from '../data';
import './About.css';

export default function About() {
  return (
    <section id="about" className="section" data-scene="adams">
      <div className="panel">
        <div className="section-head">
          <h2 className="section-head__title">Base camp</h2>
        </div>
        {about.map((p) => <p className="about__p" key={p}>{p}</p>)}

        {myPhotos.length > 0 && (
          <div className="shots">
            <h3 className="about__h">From the trail</h3>
            <div className="shots__row">
              {myPhotos.map((ph) => (
                <figure key={ph.src} className="shots__item">
                  <img src={ph.src} alt={ph.alt} loading="lazy" />
                  {ph.caption && <figcaption>{ph.caption}</figcaption>}
                </figure>
              ))}
            </div>
          </div>
        )}

        <div className="about__block">
          <h3 className="about__h">Education</h3>
          <p className="about__school">{education.school}</p>
          <p className="about__meta">
            {education.degree} · {education.gpa} GPA, {education.honors} · Graduating {education.grad}
          </p>
        </div>

        <div className="about__block">
          <h3 className="about__h">On my hiking list</h3>
          <ul className="hikes">
            {hikingList.map((h) => (
              <li key={h.name} className={h.done ? 'is-done' : ''}>
                <span className="hikes__mark" aria-hidden="true">{h.done ? '✓' : ''}</span>
                {h.name}
                <span className="hikes__note">{h.note}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
